import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=15c88e92&scoped=true"
import script from "./detail.js?vue&type=script&lang=js&external"
export * from "./detail.js?vue&type=script&lang=js&external"
import style0 from "./detail.vue?vue&type=style&index=0&id=15c88e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c88e92",
  null
  
)

export default component.exports